import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import styled from 'styled-components';
import { FUTURE_TOKENS } from '../../constants/futureTokens.js';
import { jsx } from 'react/jsx-runtime';

function getColorsByVariant() {
  var embeddedVariant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var error = theme.alertColors.error,
    _theme$CTAColors = theme.CTAColors,
    primary = _theme$CTAColors.primary,
    primaryVariant = _theme$CTAColors.primaryVariant,
    _theme$neutralColors = theme.neutralColors,
    charcoal = _theme$neutralColors.charcoal,
    smoke = _theme$neutralColors.smoke,
    white = _theme$neutralColors.white;
  var errorVariant = FUTURE_TOKENS.BADGE_ERROR_VARIANT_BACKGROUND_COLOR;
  var colorsByVariant = {
    primary: {
      bgColor: white,
      bgColorActive: white,
      bgColorHover: white,
      borderColor: white,
      borderColorActive: white,
      borderColorHover: white,
      color: primary,
      colorActive: primaryVariant,
      colorHover: primaryVariant
    },
    secondary: {
      bgColor: primary,
      bgColorActive: primary,
      bgColorHover: primaryVariant,
      borderColor: primary,
      borderColorActive: primary,
      borderColorHover: primaryVariant,
      color: white,
      colorActive: white,
      colorHover: white
    },
    tertiary: {
      bgColor: charcoal,
      bgColorActive: charcoal,
      bgColorHover: charcoal,
      borderColor: charcoal,
      borderColorHover: charcoal,
      borderColorActive: charcoal,
      color: white,
      colorActive: white,
      colorHover: white
    },
    ghost: {
      bgColor: smoke,
      bgColorActive: smoke,
      bgColorHover: smoke,
      borderColor: smoke,
      borderColorHover: smoke,
      borderColorActive: smoke,
      color: white,
      colorActive: white,
      colorHover: white
    },
    warning: {
      bgColor: white,
      bgColorActive: white,
      bgColorHover: white,
      borderColor: white,
      borderColorHover: white,
      borderColorActive: white,
      color: error,
      colorActive: errorVariant,
      colorHover: errorVariant
    },
    default: {
      bgColor: "transparent",
      bgColorActive: charcoal,
      bgColorHover: primary,
      borderColor: smoke,
      borderColorActive: charcoal,
      borderColorHover: primary,
      color: smoke,
      colorActive: white,
      colorHover: white
    },
    alert: {
      bgColor: error,
      bgColorActive: errorVariant,
      bgColorHover: errorVariant,
      borderColor: error,
      borderColorHover: errorVariant,
      borderColorActive: errorVariant,
      color: white,
      colorActive: white,
      colorHover: white
    }
  };
  return colorsByVariant[embeddedVariant];
}
var StyledBadge = styled("span").withConfig({
  displayName: "Badge__StyledBadge",
  componentId: "sc-q6y3v2-0"
})(function (_ref) {
  var _disabled = _ref._disabled,
    active = _ref.active,
    hover = _ref.hover,
    selected = _ref.selected,
    theme = _ref.theme,
    variant = _ref.variant;
  var _theme$neutralColors2 = theme.neutralColors,
    pearl = _theme$neutralColors2.pearl,
    silver = _theme$neutralColors2.silver;
  var _getColorsByVariant = getColorsByVariant(variant, theme),
    bgColor = _getColorsByVariant.bgColor,
    bgColorActive = _getColorsByVariant.bgColorActive,
    bgColorHover = _getColorsByVariant.bgColorHover,
    borderColor = _getColorsByVariant.borderColor,
    borderColorActive = _getColorsByVariant.borderColorActive,
    borderColorHover = _getColorsByVariant.borderColorHover,
    color = _getColorsByVariant.color,
    colorActive = _getColorsByVariant.colorActive,
    colorHover = _getColorsByVariant.colorHover;
  var styles = {
    backgroundColor: bgColor,
    borderColor: borderColor,
    color: color
  };
  return "\n            display: inline-block;\n            background-color: ".concat(styles.backgroundColor, ";\n            border-radius: 4px;\n            border: 2px solid ").concat(styles.borderColor, ";\n            padding: 0px 4px;\n            color: ").concat(color, " !important;\n            line-height: 16px;\n            font-weight: 600;\n            font-size: 14px;\n            text-align: center;\n\n            ").concat(active ? "background-color: ".concat(bgColorActive, ";\n                       border-color: ").concat(borderColorActive, ";\n                       color: ").concat(colorActive, " !important;") : "", ";\n            ").concat(selected || hover && !active || styles[":focus"] ? "background-color: ".concat(bgColorHover, ";\n                       border-color: ").concat(borderColorHover, ";\n                       color: ").concat(colorHover, " !important;") : "", ";\n            ").concat(_disabled ? "background-color: ".concat(pearl, ";\n                       border-color: ").concat(pearl, ";\n                       color: ").concat(silver, " !important;") : "", ";\n        ");
});
var Badge = /*#__PURE__*/React.forwardRef(function Badge2(props, ref) {
  var styleModifiers = {
    _disabled: props.disabled,
    active: props.active,
    selected: props.selected,
    hover: props.hover
  };
  var truncatedCount = props.count && props.count > 99 && props.truncateCount ? "+99" : props.count;
  return /*#__PURE__*/jsx(StyledBadge, _objectSpread(_objectSpread(_objectSpread({}, styleModifiers), {}, {
    "aria-disabled": props.disabled
  }, props), {}, {
    ref: ref,
    children: truncatedCount
  }));
});
Badge.displayName = "Badge";

export { Badge };
